import ItemDetails from './ItemDetails';
import CatalogModal from './CatalogModal';
import ConfirmationModal from './ConfirmationModal';
import RejectionReason from './RejectionReason';
import PdfPreviewModal from './PdfPreviewModal';
import SendBackModal from './SendBackModal';
import SendBackModalFinalApproval from './SendBackModalFinalApproval';
import NumberEntryModal from './NumberEntryModal';
import UpdateThresholdValueModal from './OcifUpdateThresholdValueModal';
import CancelWaiverConfirmationModal from './CancelWaiverConfirmationModal';
import { RequestExtensionModal } from '../../components/Workpage/OcifRequestExtensionButton';

const MODALS = Object.entries({
  ItemDetails,
  NumberEntryModal,
  CatalogModal,
  ConfirmationModal,
  RejectionReason,
  PdfPreviewModal,
  SendBackModal,
  SendBackModalFinalApproval,
  UpdateThresholdValueModal,
  CancelWaiverConfirmationModal,
  RequestExtensionModal,
}).reduce((_, [name, Component]) => {
  _[name] = {
    Component,
    params: Component.PARAMS,
  };

  return _;
}, {});

export default MODALS;
